module.exports = __webpack_public_path__ + "resources/img/img_passxpertv4_4_en.711176f20798ea1aeeb6984f4b088137.png";